document.addEventListener("DOMContentLoaded", function() {

	//if this is the products archive
	if(document.body.classList.contains('post-type-archive-products')) {

		//this will contain the last time a request was run (to prevent multiple firing at once)
		let last_request = 0;

		//this will store our previous tax query so we can compare previous/new requests
		let prev_tax_query = false;

		//fetch all product selects on this page
		let product_selects = document.getElementsByClassName('custom-product-select');

		//loop over the product selects we've found
		for(let i = 0; i < product_selects.length; i++) {

			//add our onchange event
			product_selects[i].onchange = function(event) {

				//trigger this lookup
				custom_product_lookup(event.target, (i + 1));
			};

			//if the value for this dropdown isn't empty
			if(product_selects[i].value != '') {

				//trigger the event now
				custom_product_lookup(event.target, (i + 1), true);
			}
		}

		function custom_product_lookup(target, pos, force) {

			//identify where we want our dropdown stylesheet to be
			let stylesheet = document.getElementById('bt-sizes-dropdown-logic');

			//if we don't have a stylesheet
			if(!stylesheet) {

				//create one
				document.head.insertAdjacentHTML("beforeend", `<style id="bt-sizes-dropdown-logic"></style>`);
				stylesheet = document.getElementById('bt-sizes-dropdown-logic');
			}

			//calculate the current time
			let current_time = Math.floor(Date.now() / 1000);

			//if it's not been 1s since the last request
			if(force || !force && last_request < (current_time - 1)) {

				//set the timestamp of the last request
				last_request = (current_time - 1);

				//create a new xhr
				const xhr = new XMLHttpRequest();

				//the following code will run on state change
				xhr.addEventListener("readystatechange", function () {
					if (this.readyState === this.DONE) {

						//this will be the response from the backend
						let response = JSON.parse(this.responseText);

						//this will contain an array of options that haven't changed based on the new selections
						let whitelisted_values = [];

						//start our styles list
						let styles = '';

						//loop over the responding dropdowns
						Object.entries(response).forEach(([name, values]) => {

							//write our styles that will disable each option by default
							styles = styles + '.custom-product-select[name="' + name + '"] option { display: none }';
							styles = styles + 'li[id^="select2-' + name + '-"] { display: none }';

							values.forEach((value) => {

								//push to our whitelist
								whitelisted_values.push(value);

								//write styles that will make our valid options available for use
								styles = styles + '.custom-product-select[name="' + name + '"] option[value="' + value + '"] { display: block !important }';
								styles = styles + 'li[id^="select2-' + name + '-"][id$="-' + value + '"] { display: block !important }';
							});
						});

						//creates a change event we can use to kick select2
						let change_event = new Event('change');

						//start our loop at the current position
						for(let i = pos; i < product_selects.length; i++) {

							//if this value hasn't also been returned by the API
							if(!whitelisted_values.includes(product_selects[i].value)) {

								//reset the dropdown
								product_selects[i].value = '';
								product_selects[i].dispatchEvent(change_event);
							}
						}

						//append our styles
						stylesheet.innerHTML = styles;
					}
				});

				//prep our XHR request
				xhr.open("POST", '/wp-json/laserred/products/dropdowns');
				xhr.setRequestHeader("Accept", "*/*");
				xhr.setRequestHeader("Content-Type", "application/json");

				//start building a new tax query for all our dropdowns
				let tax_query = {};

				//create empty variables for our master and active taxonomies
				let master_tax = false;
				let active_tax = false;

				//loop over the select dropdowns
				for(let i = 0; i < product_selects.length; i++) {

					//add a key value pair for this dropdown
					tax_query[product_selects[i].name] = product_selects[i].value;
				}

				//if we don't have a previous tax query
				if(!prev_tax_query) {

					//use the current one
					prev_tax_query = tax_query;
				}

				//loop over the current tax query
				for (const [name, value] of Object.entries(tax_query)) {

					//if we don't have a master tax
					if(!master_tax) {

						//set it to the first element in the loop
						master_tax = name;
					}

					//if the new value is different from the previous value
					if(value != '' && (value != prev_tax_query[name] || master_tax && tax_query[master_tax] == '')) {

						//this is our active tax
						active_tax = name;
					}
				}

				//save our tax query
				prev_tax_query = tax_query;

				//make our request with the current tax query
				xhr.send(JSON.stringify({
					'master': master_tax,
					'active': active_tax ? active_tax : master_tax,
					'dropdowns': tax_query
				}));
			} else {
				console.warn('Too many dropdown requests, please wait.');
			}
		}
	}
});